/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Nav_Stock_Out_NotesInputs */

const vi_pkl_nav_stock_out_notes = /** @type {(inputs: Pkl_Nav_Stock_Out_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất`)
};

/**

* @param {Pkl_Nav_Stock_Out_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_nav_stock_out_notes = /** @type {((inputs?: Pkl_Nav_Stock_Out_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Nav_Stock_Out_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_nav_stock_out_notes(inputs)
});